module.exports = __webpack_public_path__ + "static/media/gis4.017a001f.png";